export const fitting = `
[Hyperion, Hyperion - Entry/Alpha Incursions]
Tracking Enhancer II
Tracking Enhancer II
Damage Control II
Magnetic Field Stabilizer II
Magnetic Field Stabilizer II
Magnetic Field Stabilizer II
Magnetic Field Stabilizer II

Multispectrum Shield Hardener II
Multispectrum Shield Hardener II
Large Shield Extender II
Pithum C-Type EM Shield Amplifier
500MN Quad LiF Restrained Microwarpdrive

Modal Mega Neutron Particle Accelerator I
Modal Mega Neutron Particle Accelerator I
Modal Mega Neutron Particle Accelerator I
Modal Mega Neutron Particle Accelerator I
Modal Mega Neutron Particle Accelerator I
Modal Mega Neutron Particle Accelerator I
Heavy Knave Scoped Energy Nosferatu

Large EM Shield Reinforcer I
Large Thermal Shield Reinforcer I
Large Core Defense Field Extender I

Federation Navy Ogre x5

Nanite Repair Paste x50
Caldari Navy Tungsten Charge L x1
Caldari Navy Antimatter Charge L x1
`
